import './Loader.scss';

function Loader({small}: any) {
    if(small){
        return (
            <div className="loadingio-spinner-ellipsis-nq4q5u6dq7r"><div className="ldio-x2uulkbinbj">
                <div></div><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }
    return (
        <div className="loadingio-spinner-ripple-t2pmf05m2mr">
            <div className="ldio-7ze32knibrv">
                <div></div>
                <div></div>
            </div>
        </div>
    );
}


export default Loader;
